import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AboutProperty from './response-pages/AboutProperty';
import ResponseTest from './response-pages/ResponseTest';
import PropertyFacilities from './response-pages/PropertyFacilities';
import RoomAmenities from './response-pages/RoomAmenities';
import SpecialEmergencies from './response-pages/SpecialEmergencies';
import PropertyContact from './response-pages/PropertyContact';
import PropertyActivities from './response-pages/PropertyActivities';
import PropertyLocation from './response-pages/PropertyLocation';
import AboutRooms from './about-rooms';
import RhAboutProperty from './response-pages/RhAboutProperty';
import RelatedTopics from './response-pages/RelatedTopics';
import AssistantOptions from './response-pages/AssistantOptions';
import HotelAssistantOptions from './response-pages/HotelAssistantOptions';
import SalonInformation from './response-pages/SalonInformation';
import SalonServices from './response-pages/SalonServices';
import Services from './services';
import Locations from './locations';
import SalonAssistantOptions from './response-pages/SalonAssistantOptions';
import Gallery from './gallery';
import HolidayParkContact from './response-pages/HolidayParkContact';
import HolidayParkFacilities from './response-pages/HolidayParkFacilities';
import HolidayParkInformation from './response-pages/HolidayParkInformation';
import HolidayParkLocation from './response-pages/HolidayParkLocation';
import HolidayParkAssistantOptions from './response-pages/HolidayParkAssistantOptions';
import QBotAssistantOptions from './response-pages/QBotAssistantOptions';
import QBotInformation from './response-pages/QBotInformation';
import HolidayHomesAmenties from './response-pages/HolidayHomesAmenties';
import HolidayHomesAssistantOptions from './response-pages/HolidayHomesAssistantOptions';
import HolidayHomesInformation from './response-pages/HolidayHomesInformation';
import HolidayHomesBedRooms from './response-pages/HolidayHomesBedRooms';
import HolidayHomesPolicies from './response-pages/HolidayHomesPolicies';
import VVNAssistantOptions from './response-pages/VVNAssistantOptions';
import VVNInformation from './response-pages/VVNInformation';
import DCAssistantOptions from './response-pages/DCAssistantOptions';
import DCInformation from './response-pages/DCInformation';
import DCVoice from './response-pages/DCVoice';
import NorthableAbout from './response-pages/NorthableAbout';
import NorthableEquipment from './response-pages/NorthableEquipment';
import NorthableHelpline from './response-pages/NorthableHelpline';
import GolfProperty from './response-pages/GolfProperty';
import GolfServices from './response-pages/GolfServices';
import GolfGeneral from './response-pages/GolfGeneral';
import Recommender from './Recommender';
import products from './products';
import FavResponse from './response-pages/FavResponse';
const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/general-info`} />
      <Route path={`${match.url}/about-property`} component={AboutProperty} />
      <Route
        path={`${match.url}/property-facilities`}
        component={PropertyFacilities}
      />
      <Route path={`${match.url}/room-amenities`} component={RoomAmenities} />
      <Route
        path={`${match.url}/property-contact`}
        component={PropertyContact}
      />
      <Route
        path={`${match.url}/property-activities`}
        component={PropertyActivities}
      />
      <Route
        path={`${match.url}/property-location`}
        component={PropertyLocation}
      />
      <Route path={`${match.url}/emergencies`} component={SpecialEmergencies} />
      <Route path={`${match.url}/response-test`} component={ResponseTest} />
      <Route path={`${match.url}/about-rooms`} component={AboutRooms} />
      <Route
        path={`${match.url}/about-rhproperty`}
        component={RhAboutProperty}
      />
      <Route path={`${match.url}/related-topics`} component={RelatedTopics} />
      <Route
        path={`${match.url}/assistant-options`}
        component={AssistantOptions}
      />
      <Route
        path={`${match.url}/hotel-assistant-options`}
        component={HotelAssistantOptions}
      />
      <Route
        path={`${match.url}/salon-information`}
        component={SalonInformation}
      />
      <Route path={`${match.url}/salon-services`} component={SalonServices} />
      <Route path={`${match.url}/services`} component={Services} />
      <Route path={`${match.url}/locations`} component={Locations} />
      <Route
        path={`${match.url}/salon-assistant-options`}
        component={SalonAssistantOptions}
      />
      <Route path={`${match.url}/hp-contact`} component={HolidayParkContact} />
      <Route
        path={`${match.url}/hp-location`}
        component={HolidayParkLocation}
      />
      <Route
        path={`${match.url}/hp-facilities`}
        component={HolidayParkFacilities}
      />
      <Route
        path={`${match.url}/hp-information`}
        component={HolidayParkInformation}
      />
      <Route path={`${match.url}/gallery`} component={Gallery} />
      <Route
        path={`${match.url}/hp-assistant-options`}
        component={HolidayParkAssistantOptions}
      />
      <Route
        path={`${match.url}/qbot-assistant-options`}
        component={QBotAssistantOptions}
      />
      <Route
        path={`${match.url}/qbot-information`}
        component={QBotInformation}
      />
      <Route
        path={`${match.url}/hh-amenities`}
        component={HolidayHomesAmenties}
      />
      <Route
        path={`${match.url}/hh-assistant-options`}
        component={HolidayHomesAssistantOptions}
      />
      <Route
        path={`${match.url}/hh-information`}
        component={HolidayHomesInformation}
      />
      <Route
        path={`${match.url}/hh-policies`}
        component={HolidayHomesPolicies}
      />
      <Route
        path={`${match.url}/hh-bedrooms`}
        component={HolidayHomesBedRooms}
      />
      <Route
        path={`${match.url}/vvn-assistant-options`}
        component={VVNAssistantOptions}
      />
      <Route path={`${match.url}/vvn-information`} component={VVNInformation} />
      <Route path={`${match.url}/recommender`} component={Recommender} />
      <Route path={`${match.url}/products`} component={products} />
      <Route
        path={`${match.url}/dc-assistant-options`}
        component={DCAssistantOptions}
      />
      <Route
        path={`${match.url}/clinic-information`}
        component={DCInformation}
      />
      <Route path={`${match.url}/dc-voice`} component={DCVoice} />
      <Route path={`${match.url}/northable-about`} component={NorthableAbout} />
      <Route
        path={`${match.url}/northable-equipment`}
        component={NorthableEquipment}
      />
      <Route
        path={`${match.url}/northable-helpline`}
        component={NorthableHelpline}
      />
      <Route path={`${match.url}/golf-property`} component={GolfProperty} />
      <Route path={`${match.url}/golf-services`} component={GolfServices} />
      <Route path={`${match.url}/golf-general`} component={GolfGeneral} />
      <Route path={`${match.url}/favourite-response`} component={FavResponse} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
